import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Skighnet · Amplify Gen 2</p>
        <h1>Elevate Your Digital Experience</h1>
        <p className="lede">
          Discover innovative solutions designed to enhance your online presence. Our platform empowers you to create, manage, and optimize your digital assets effortlessly.
        </p>
        <div className="cta-row">
          <a href="https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html" target="_blank">
            Explore Amplify Docs
          </a>
          <a href="https://github.com/skighnet" target="_blank" className="secondary">
            Learn More About Skighnet
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Launch with Ease</h2>
          <p>
            Seamlessly deploy your projects with our integrated tools that automate the build and hosting process, allowing you to focus on what matters most.
          </p>
        </article>
        <article>
          <h2>Tailor Your Solutions</h2>
          <p>
            Customize every aspect of your site with flexible components and powerful APIs, ensuring your digital presence reflects your unique brand identity.
          </p>
        </article>
        <article>
          <h2>Stay Ahead with Automation</h2>
          <p>
            Utilize our automation features to keep your content fresh and engaging, with scheduled updates that save you time and enhance user experience.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;